import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import I18N from "../I18N";
import { BinaryToggle } from "./BinaryToggle";
import { SettingsPremiumBadge } from "./SettingsPremiumBadge";
import { default_currency } from "../Site";

export const GameMechanicsSection = ({ me, simple_checkbox_change, RadiosAndCustom, this_parent, state_invalid_input, state, nolimit_txt, other_txt, amount_txt, render_static, NoEdit}) => {
    return (
        <React.Fragment>
            <span className="txt-15px"><T>Here you can adjust the game mechanics and rules. Use them to make the game more realistic and to promote good investment practices such as risk diversification.</T></span>
            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/max-amount-one-equity-0.svg"/><span className="ad_120_bold pl-2"><T>Max. amount in one equity</T></span>
                    <p>
                    <small><T>Prevent participants from going all-in on a single stock - encourages diversification.</T></small><br/>
                    </p>
                    <RadiosAndCustom
                        name="max_amount_per_stock"
                        parent={this_parent}
                        defaults={[
                            {"value": "nolimit", "text": nolimit_txt},
                            {"value": "20%", "text": <span>{I18N.floatval_unit(state.bankroll*0.2, 0, state.currency)} (20%)</span>},
                        ]}
                        custom_text={other_txt}
                        custom_placeholder={render_static(amount_txt)}
                        custom_error={state_invalid_input === "max_amount_per_stock"}
                        min={1}
                        max={10000000}
                    />
                </Col>
            </Row>
            

            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" /><span className="ad_120_bold pl-2"><T>Trade volume reflection</T></span><SettingsPremiumBadge />
                    <p>
                        <small><T>Prevent players from exploiting the delay between in-game and real-time prices. Use trading volume from real markets to reflect how much can be bought in the game.</T></small><br/>
                    </p>
                    <div className="text-left">
                        <BinaryToggle 
                            name={"use_volume"}
                            checked={state.use_volume}
                            onChange={simple_checkbox_change}
                            labels={[<T>Activate</T>, <T>Deactivate</T>]}
                        />
                    </div>
                </Col>
            </Row>

            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
                        <span className="ad_120_bold pl-2"><T>Player trade limits</T></span><SettingsPremiumBadge />
                            <p>
                                <small><T>Set limits on the number of trades - great for preventing excessive day trading and ensuring players diversify their investments. Choose either a minimum, a maximum, or both.</T></small><br/>
                            </p>
                    <div className="text-left">
                            <BinaryToggle 
                            name={"trade_amount_activated"}
                            checked={state.trade_amount_activated}
                            onChange={simple_checkbox_change}
                            labels={[<T>Activate</T>, <T>Deactivate</T>]}
                            />
                    </div>
                </Col>
            </Row>

            {state.trade_amount_activated && (
                <Row className="justify-content-center">
                    <Col md="12" className="px-md-4 pt-4">
                        <img alt="" className="ad_logo_list" src="/gfx/max-amount-one-equity-0.svg"/>
                        <span className="ad_120_bold pl-2"><T>Maximum amount of trades</T></span>
                        <p>
                            <small><T>How many trades for each player</T></small><br/>
                        </p>
                        <T><RadiosAndCustom
                            name="trade_amount"
                            parent={this_parent}
                            defaults={[
                                {"value": 50, "text": "50 trades"},
                                {"value": 100, "text": "100 trades"},
                            ]}
                            custom_text="Other (max x)"
                            custom_placeholder="Enter max trades"
                            custom_error={state_invalid_input === "trade_amount"}
                            min={1}
                            max={500}
                        /></T>
                    </Col>
                </Row>
            )}

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/brokerage-color-0.svg"/><span className="ad_120_bold pl-2"><T>Brokerage</T></span>
                    <p>
                    <small><T>Add a trading fee - just like in real life. Makes the game more realistic.</T></small><br/>
                    </p>
                    <T><RadiosAndCustom
                        name="brokerage_pct"
                        parent={this_parent}
                        defaults={[
                            {"value": 0, "text": "None"},
                            {"value": 0.15, "text": "0.15%"},
                        ]}
                        custom_text="Other"
                        custom_postfix="%&nbsp;&nbsp;"
                        custom_placeholder="pct."
                        custom_error={state_invalid_input === "brokerage_pct"}
                        min={0}
                        max={50}
                        step={0.01}
                    /></T>
                </Col>
            </Row>

           {me && me.IsGod && (
             <NoEdit>
                <Row className="justify-content-center">
                    <Col md="12" className="new_game_premium px-md-4 pt-4">
                        <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
                            <span className="ad_120_bold pl-2"><T>Shorting</T></span><SettingsPremiumBadge />
                                <p>
                                    <small><T>Allow players to profit when stocks fall — they “borrow” and sell shares, then buy them back later at a lower price if successful.</T></small><br/>
                                </p>
                        <div className="text-left">
                                <BinaryToggle 
                                name={"shorting_enabled"}
                                checked={state.shorting_enabled}
                                onChange={simple_checkbox_change}
                                labels={[<T>Activate</T>, <T>Deactivate</T>]}
                                />
                        </div>
                    </Col>
                </Row>

                {state.shorting_enabled && (
                <Row className="justify-content-center">
                    <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
                    <span className="ad_120_bold pl-2"><T>Maximum shorting fraction</T></span>
                    <p>
                        <small><T>Decide how much of the starting balance players can be used for shorting. For example, 20 means 20% of their total starting funds.</T></small>
                    </p>

                    <T><RadiosAndCustom
                        name="shorting_amount"
                        parent={this_parent}
                        defaults={[
                            { "value": 10, "text": `10% (${(0.1 * state.bankroll)} ${default_currency})` },
                            { "value": 20, "text": `20% (${(0.2 * state.bankroll)} ${default_currency})` },
                            { "value": 30, "text": `30% (${(0.3 * state.bankroll)} ${default_currency})` },
                        ]}
                        custom_text="Other"
                        custom_placeholder="Procent (fx. 20)"
                        custom_error={state_invalid_input === "shorting_amount"}
                        min={1}
                        max={100}
                        step={1}
                        />
                    </T>
                    </Col>
                </Row>
                )}
            </NoEdit>
           )}
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/GameMechanicsSection.js